import React from 'react'
import { createRegisterableComposition } from '@news-mono/web-common'
import { FeatureArticleBreach } from './FeatureArticleBreach'
import { getPublicationPageProperties } from '../../templates/Publication/lib/publication-page-properties'
import { getPublicationInfoFromRouteResolution } from '../../templates/Publication/SharedPublication.routing'
import { PageProps } from 'page-lifecycle-provider'
import { RequiredAccess } from '@news-mono/web-common'

interface FeatureArticleBreachCompositionRegistrationProps {
    requiredAccess: RequiredAccess
    publicationId: string
    slug: string
}

export const FeatureArticleBreachCompositionRegistration = createRegisterableComposition<
    'main' | 'common' | 'comments'
>()(
    'article-breach-composition',
    (
        contentAreas,
        props: FeatureArticleBreachCompositionRegistrationProps,
        services,
    ) => {
        const publicationInfo = getPublicationInfoFromRouteResolution(services)

        // DPT-1856 - PageAdditionalProps required here at top most of featured article template or
        // events were firing twice, moved from TheWestFeature.routing
        return (
            <PageProps
                pageProperties={getPublicationPageProperties(
                    publicationInfo.publication,
                )}
            >
                <FeatureArticleBreach
                    requiredAccess={props.requiredAccess}
                    location={services.location}
                    onEvent={services.onEvent}
                    commonElements={contentAreas.common}
                    comments={contentAreas.comments}
                    publicationId={props.publicationId}
                    slug={props.slug}
                >
                    {contentAreas.main}
                </FeatureArticleBreach>
            </PageProps>
        )
    },
)
